function highlightRowOnMessage() {
    let elem = document.querySelector("[data-gs-program-session-index-highlight-table]")
    if (elem) {
        var highlightedElem = document.querySelector('.local-highlighted-row');
        if (highlightedElem) {
            highlightedElem.scrollIntoView();
        }
        window.addEventListener("message", (e) => {
            if (e.data["source"] && e.data["source"] === "data-gs-program-session-index-highlight") {
                let id = e.data["id"];
                if (!id) {
                    console.log("data-gs-program-session-index-highlight id is needed");
                    return;
                }
                let hightlightIdElem = document.getElementById("local-hightlight-hidden") as HTMLInputElement;
                if (!hightlightIdElem) {
                    console.log("data-gs-program-session-index-highlight need a hidden field local-hightlight-hidden");
                    return;
                }
                hightlightIdElem.value = id;
                hightlightIdElem.form.submit();
            }
        });
    }
}

function closeButtonForViewSession() {
    let elem = document.querySelector("[data-gs-program-session-view-session-close-button]") as HTMLButtonElement
    if (elem) {
        let id = elem.dataset["gsProgramSessionViewSessionCloseButtonId"];
        if (!id) {
            console.log("data-gs-program-session-view-session-close-button-id is needed");
            return;
        }
        if (elem.dataset["gsProgramSessionViewSessionCloseButtonId"]) {
            if (window.opener) {
                let parentWindow = window.opener as Window;
                parentWindow.focus();
                let message = {
                    source: "data-gs-program-session-index-highlight",
                    id: id
                };
                parentWindow.postMessage(message, "*");
            }

            elem.addEventListener("click", (e) => {
                e.preventDefault();
                window.close();
            });
        }
    }
}

export default function () {
    highlightRowOnMessage();
    closeButtonForViewSession();
}